import {ReactNode} from 'react';

import {Codes} from './Codes';
import {Description} from './Description';
import {UserInfo} from './UserInfo';

type Props = {
  userName: string;
  userPhoneNumber: string;
  hasVerificationCodes: boolean;
  userCode: string;
  agentCode: string;
  error?: ReactNode;
  loading?: boolean;
};

export function Details({
  userName,
  userPhoneNumber,
  hasVerificationCodes,
  userCode,
  agentCode,
  error,
  loading,
}: Props) {
  return (
    <>
      <Description />
      <UserInfo userName={userName} userPhoneNumber={userPhoneNumber} />
      {hasVerificationCodes ? (
        <Codes
          userCode={userCode}
          agentCode={agentCode}
          error={error}
          loading={loading}
        />
      ) : null}
    </>
  );
}
